import React, { useState } from 'react';
import { View } from 'react-native';
import { Icon } from 'react-native-elements';

import ActionModal from '../../../Componentsv1/ActionModal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';

type PostHeaderProps = {
    onSave: (status:string) => void
    onCancel: () => void
}
const PostHeader = ({ onSave, onCancel }:PostHeaderProps) => {
    const [ action_visible, setActionVisible ] = useState(false);

    const insets = useSafeAreaInsets()

    const onOptionSelect = (option:any) => {
        switch(option.option){
            case 'cancel':
                return onCancel();
            case 'draft':
                return onSave('draft');
            case 'discard':
                return onSave('deleted');
            default: return
        }
    }

    return (
        <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between',  backgroundColor:Colors.brand.electric, paddingTop: insets.top }}>
            <TouchableOpacity style={{ padding:17, flexDirection:'row', alignItems:'center' }} onPress={() => setActionVisible(true)}>
                <Icon size={16} name='chevron-left' type='feather' color={Colors.shades.white} style={{ marginRight: 5 }} />
                <Text size={14} color={Colors.shades.white}>Save & Exit</Text>
            </TouchableOpacity>
            <TouchableOpacity native_id='publish-post' style={{padding:17, flexDirection:'row', alignItems:'center'}} onPress={() => onSave('visible')}> 
                <Text size={14} color={Colors.shades.white} weight='regular'>Publish</Text>
            </TouchableOpacity>
            <ActionModal 
                options={[
                    { option: 'cancel', label: 'Go Back' },
                    { option: 'draft', label: 'Save as Draft', color:Colors.utility.success },
                    { option: 'discard', label:'Discard / Delete', color:Colors.utility.error }
                ]}
                label_attribute='label'
                onSelectOption={(option) => onOptionSelect(option)}
                isVisible={action_visible}
                closeModal={() => setActionVisible(false)}
            />
        </View>
    )
}

export default PostHeader